import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IDuplicateTransactionsMeta{
  date: FormInputMeta,
  shareHolderNumber: FormInputMeta, 
  transactionCode: FormInputMeta,
  trader: FormInputMeta,
  traderCategoryCode: FormInputMeta,
  transactionAmount: FormInputMeta,
  authorizationNumber: FormInputMeta,
  currencyTransaction: FormInputMeta,
  bank: FormInputMeta,
  schema: any,
}

const DuplicateTransactionsMeta: IDuplicateTransactionsMeta= {} as IDuplicateTransactionsMeta;

DuplicateTransactionsMeta.bank = commonFormMeta.bank;

DuplicateTransactionsMeta.date = {
  label: 'Date',
  name: 'date',
  type: 'date',
  placeholder: 'Date',
  validation: yup.string().required(),
}

DuplicateTransactionsMeta.shareHolderNumber = {
  name: "shareHolderNumber",
  type: "checkbox",
  label: "Transaction Code",
  validation: yup.boolean()
};

DuplicateTransactionsMeta.transactionCode = {
  name: "transactionCode",
  type: "checkbox",
  label: "Transaction Code",
  validation: yup.boolean()
};

DuplicateTransactionsMeta.trader = {
  name: "trader",
  label: "Commerçant",
  type: "checkbox",
  validation: yup.boolean(),
};

DuplicateTransactionsMeta.traderCategoryCode = {
  name: "traderCategoryCode",
  label: "Code catégorie commerçant",
  type: "checkbox",
  validation: yup.boolean(),
};

DuplicateTransactionsMeta.transactionAmount = {
  name: "transactionAmount",
  label: "Montant de la transaction",
  type: "checkbox",
  validation: yup.boolean(),
};

DuplicateTransactionsMeta.authorizationNumber = {
  name: "authorizationNumber",
  label: "Numéro d'autorisation",
  type: "checkbox",
  validation: yup.boolean(),
};

DuplicateTransactionsMeta.currencyTransaction = {
  name: "curencyTransaction",
  label: "Dévises de la transaction",
  type: "checkbox",
  validation: yup.boolean(),
};

const validationSchema: any = {};

for (let fieldname in DuplicateTransactionsMeta) {
  validationSchema[fieldname] = (DuplicateTransactionsMeta as any)[fieldname].validation;
}

DuplicateTransactionsMeta.schema = yup.object().shape(validationSchema);

export default DuplicateTransactionsMeta;

